import { defineComponent, Ref, inject, ref, computed, onMounted } from 'vue';
import { LocationModel, ILocationActionsService } from '@truckdown/locations';
import { locationKey, locationUpdateKey } from '../keys';
import context from '@truckdown/components-systems';
import { ILookupService } from '@truckdown/systems';
import { showMessage } from '../../utilities';

interface ILocationAdminInfo {
    ratingValue: number,
    createdDate: string,
    modifiedDate: string,
    verifiedDate: string,
    verifiedBy: string,
    verifiedByName: string,
}

interface IData {
    editLocation: Ref<LocationModel>,
    locationAdminInfo: Ref<ILocationAdminInfo>
}

const getCreatedDateFromObjectId = function (objectId: string | { toString(): string }): string {
    const idStr = objectId.toString();
    const timestampHex = idStr.substring(0, 8);
    const timestampSeconds = parseInt(timestampHex, 16);
    return new Date(timestampSeconds * 1000).toLocaleString();
}

const getInitialData = (props: any): IData => {
    const injectedLocation = inject<Ref<LocationModel>>(locationKey)!;
    const ratingValue = injectedLocation.value.properties.ratingValue?.value || 0;
    const verifiedDate = new Date(injectedLocation.value.properties.lastVerifiedDate);
    const modifiedDate = new Date(injectedLocation.value.properties.modifiedTime);

    return {
        editLocation: injectedLocation,
        locationAdminInfo: ref<ILocationAdminInfo>({
            ratingValue: ratingValue <= 0 || ratingValue == undefined ? 0 : injectedLocation.value.properties.ratingValue.value,
            createdDate: getCreatedDateFromObjectId(injectedLocation.value.id),
            modifiedDate: modifiedDate.getFullYear() === 0 ? "Not verified" : verifiedDate.toLocaleString(),
            verifiedDate: verifiedDate.getFullYear() === 0 ? "Not verified" : verifiedDate.toLocaleString(),
            verifiedBy: injectedLocation.value.properties.lastVerifiedBy,
            verifiedByName: ""
        })
    };
};

const getMethods = (data: IData, props: any, ctx: any) => {
   
    return {
        verifyListing: async function () {
            const manager = await context.getService<ILocationActionsService>('ILocationActionsService');
            try {
                if (data.editLocation.value) {
                    let result = await manager.verify(data.editLocation.value.id);
                    if (result && result.ok) {
                        data.locationAdminInfo.value.verifiedByName = result.data?.verifiedBy || data.locationAdminInfo.value.verifiedByName;
                        data.locationAdminInfo.value.verifiedDate = new Date(result.data?.verifiedDate || data.locationAdminInfo.value.verifiedDate).toLocaleString();
                        showMessage(`Listing was successfully verified`, "success", true, true);
                        return true;
                    } else {
                        return false;
                    }
                }
            } catch (error) {
                console.error('Listing Verification Failed:', error);
            }
            return false;
        }
    };
};

export default defineComponent({
    props: {
        isAdmin: Boolean,
        editState: Boolean,
        selectedSite: { type: String, default: context.system },
        showViewBtn: Boolean
    },
    name: "EditFooter",
    emits: ['open-edit', 'open-hours'],
    setup(props, ctx) {
        const data = getInitialData(props);
        const methods = getMethods(data, props, ctx);

        const getCSRName = async function (data: IData) {
            try {
                let mgr = await context.getService<ILookupService>('ILookupService');
                let csrs = await mgr.getCsrs();
                let csr = csrs.find(obj => obj.id == data.locationAdminInfo.value.verifiedBy);
                return csr ? `${csr.firstName} ${csr.lastName}` : "";

            } catch (err) {
                console.error(err)
                return "";
            }
        }

        onMounted(async () => {
            data.locationAdminInfo.value.verifiedByName = await getCSRName(data);
        });


        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});

